import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=aa1cde6c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=aa1cde6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1cde6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa1cde6c')) {
      api.createRecord('aa1cde6c', component.options)
    } else {
      api.reload('aa1cde6c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=aa1cde6c&scoped=true&", function () {
      api.rerender('aa1cde6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YTllu34z80my/JS/comp/SearchFilterTokens.vue"
export default component.exports